import {
  ApolloClient,
  ApolloLink,
  concat,

  HttpLink,
  InMemoryCache
} from "@apollo/client";
import { onError } from "@apollo/client/link/error";

const httpLink = new HttpLink({ uri: process.env.REACT_APP_API_BASE_URL });

// const getNewToken = () => {
//   // return apolloClient.query({ query: GET_TOKEN_QUERY }).then((response) => {
//   //   // extract your accessToken from your response data and return it
//   //   const { accessToken } = response.data;
//   //   return accessToken;
//   // });

//   const payload: any = {
//     client_id: "clientid",
//     client_secret: "clientsecret",
//     grant_type: "client_credentials",
//     //refresh_token:hdh922
//   };
  

//   const data = new FormData();
//   data.append("json", JSON.stringify(payload));

//   return fetch("http://ec2-184-73-80-152.compute-1.amazonaws.com:200/token", {

//     headers: {"Content-type": "application/x-www-form-urlencoded"},
//     method: "POST",
//     // headers: {
//     //   "Content-type": "application/x-www-form-urlencoded",
//     // },
//     body: 'client_id=clientid&client_secret=clientsecret&grant_type=client_credentials&refresh_token=hdh922'
//   }).then((response: any) => {
//     console.log("response ----");
//     console.log(response);
//     console.log(response.access_token);
//     return response.access_token;
//   });
// };

// let isRefreshing = false;
// let pendingRequests: any = [];

// const resolvePendingRequests = () => {
//   pendingRequests.map((callback: any) => callback());
//   pendingRequests = [];
// };

const errorLink = onError(
  ({ graphQLErrors, networkError, operation, forward }) => {
    if (graphQLErrors) {
      for (let err of graphQLErrors) {
        console.log('GraphQL Error: ');
        console.log(err);
        // switch (err?.extensions?.code) {
        //   case "UNAUTHENTICATED":
        //     // error code is set to UNAUTHENTICATED
        //     // when AuthenticationError thrown in resolver
        //     let forward$;

        //     if (!isRefreshing) {
        //       isRefreshing = true;
        //       forward$ = fromPromise(
        //         getNewToken()
        //           .then((response: any) => {
        //             // Store the new tokens for your auth link
        //             localStorage.setItem("token", response.accessToken);
        //             resolvePendingRequests();
        //             return response.accessToken;
        //           })
        //           .catch((error: any) => {
        //             pendingRequests = [];
        //             // Handle token refresh errors e.g clear stored tokens, redirect to login, ...
        //             return;
        //           })
        //           .finally(() => {
        //             isRefreshing = false;
        //           })
        //       ).filter((value) => Boolean(value));
        //     } else {
        //       // Will only emit once the Promise is resolved
        //       forward$ = fromPromise(
        //         new Promise((resolve) => {
        //           pendingRequests.push(() => resolve());
        //         })
        //       );
        //     }

        //     return forward$.flatMap(() => forward(operation));
        // }
      }
    }
    if (networkError) {
      console.log(`[Network error]: ${networkError}`);
      // if you would also like to retry automatically on
      // network errors, we recommend that you use
      // apollo-link-retry
    }
  }
);

const authLink = new ApolloLink((operation, forward) => {
  // add the authorization token in the header.
  operation.setContext({
    headers: {
      // TODO: Get the token from the store once it is implemented.
      // authorization: 'Authorization=Bearer ' + localStorage.getItem("token") || null,
      authorization: null,
    },
  });

  return forward(operation);
});

const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: concat(errorLink, concat(authLink, httpLink)),
  defaultOptions: {
    query: {
      fetchPolicy: "network-only",
    },
  },
});

export const ApiService = {
  getApolloClient() {
    return client;
  },
};
